import { type AxiosInstance } from 'axios';
import appSettings from '@/config/index';
import { logger } from '@/infra/logging';
import { sleep, calculateBackoff } from '@/shared/utils/retry';
import type { RetryableRequestConfig } from '../../api.types';

export async function retryRequest(
  originalRequest: RetryableRequestConfig,
  axiosInstance: AxiosInstance
): Promise<never> {
  const retryCount = originalRequest._retry ?? 0;
  originalRequest._retry = retryCount + 1;

  const delay = calculateBackoff(retryCount, appSettings.api.retry);
  await sleep(delay);

  logger.warn(`Retrying request (attempt ${retryCount + 1}/${appSettings.api.retry.maxRetries})`, {
    component: 'ApiClient.ResponseInterceptor',
    url: originalRequest.url,
    method: originalRequest.method?.toUpperCase(),
    delay,
  });

  return axiosInstance(originalRequest);
}
